<template>
	<div class="digital-human-page">
		<div class="digital-human-list">
			<div class="list-grid">
				<div class="new-canvas-card" @click="handleCreateNew">
					<div class="new-canvas-bg">
						<div class="new-canvas-icon">
							<i class="el-icon-plus"></i>
						</div>
						<span class="new-canvas-text">创建画布</span>
					</div>
					<div class="new-canvas-desc">从空白开始</div>
					<div class="new-canvas-sub">自由组合素材，创作你的故事</div>
				</div>
				<div v-for="canvas in canvases" :key="canvas.canvasId" class="human-card"
					:class="{ selected: selectedId === canvas.canvasId }" @click="handleSelect(canvas.canvasId)">
					<div class="card-preview">
						<template v-if="canvas.canvasContent">
							<el-image v-if="isImageUrl(canvas.canvasContent)" :src="canvas.canvasContent" fit="cover" />
							<div v-else-if="isAudioUrl(canvas.canvasContent)" class="preview-audio">
								<el-audio :src="canvas.canvasContent" />
							</div>
							<video v-else-if="isVideoUrl(canvas.canvasContent)" :src="canvas.canvasContent"
								class="preview-video" controls />
							<div v-else class="preview-text">{{ truncateText(canvas.canvasContent) }}</div>
						</template>
						<el-image v-else :src="canvas.canvasImage || ''" fit="cover" />
					</div>
					<div class="card-info">
						<h3 class="card-name">{{ canvas.canvasUName}}</h3>
					</div>
					<div class="card-time">{{ formatTime(canvas.canvasAddTime) }}</div>
					<div class="card-actions">
						<el-button size="mini" @click.stop="handleEdit(canvas)">编辑</el-button>
						<el-button size="mini" type="danger" @click.stop="handleDelete(canvas.canvasId)">删除</el-button>
					</div>
				</div>
			</div>
			<div class="list-footer">
				<span v-if="canvases.length === 0">没有更多画布了</span>
				<el-pagination v-else @size-change="handlePageSizeChange" @current-change="handlePageChange"
					:current-page="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageCount"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'

	const BASE_URL = 'https://ai.boningnet.cn/api'

	export default {
		name: 'Assignment',
		data() {
			return {
				canvases: [],
				selectedId: null,
				pageNum: 1,
				pageCount: 20,
				total: 0,
				adminInfo: {}
			}
		},
		mounted() {
			const info = localStorage.getItem('adminInfo')
			if (info) {
				this.adminInfo = JSON.parse(info)
			}
			this.fetchList()
		},
		methods: {
			fetchList() {
				const params = {
					token: this.adminInfo.adminToken,
					pageNum: this.pageNum,
					pageCount: this.pageCount
				}
				if (this.adminInfo.adminLevel > 0) {
					params.adminId = this.adminInfo.adminId
				}
				axios.get(`${BASE_URL}/canvas/list`, {
					params
				}).then(res => {
					const data = res.data || {}
					this.canvases = data.list || data || []
					if (this.canvases.length == 0) {
						this.total=0
						//this.$message.info('暂无画布')
					} else {
						this.total = data[0].allcount
					}
				}).catch(() => {
					this.$message.error('获取画布列表失败')
				})
			},
			handlePageChange(val) {
				this.pageNum = val
				this.fetchList()
			},
			handlePageSizeChange(val) {
				this.pageCount = val
				this.pageNum = 1
				this.fetchList()
			},
			formatTime(timeStr) {
				if (!timeStr) return ''
				const date = new Date(timeStr)
				const month = (date.getMonth() + 1).toString().padStart(2, '0')
				const day = date.getDate().toString().padStart(2, '0')
				const hours = date.getHours().toString().padStart(2, '0')
				const minutes = date.getMinutes().toString().padStart(2, '0')
				return `${month}月${day}日 ${hours}:${minutes}`
			},
			handleCreateNew() {
				this.$router.push('/canvas')
			},
			isImageUrl(url) {
				return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url)
			},
			isAudioUrl(url) {
				return /\.(mp3|wav|ogg|flac)$/i.test(url)
			},
			isVideoUrl(url) {
				return /\.(mp4|webm|avi|mov)$/i.test(url)
			},
			truncateText(text) {
				return text.length > 50 ? text.substring(0, 50) + '...' : text
			},
			handleSelect(id) {
				this.selectedId = id
			},
			handleEdit(canvas) {
				this.$router.push(
					`/canvas?canvasId=${canvas.canvasId}&canvasName=${encodeURIComponent(canvas.canvasUName)}`)
			},
			handleDelete(id) {
				this.$confirm('确定要删除这个画布吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					axios.get(`${BASE_URL}/canvas/delete?token=${this.adminInfo.adminToken}&canvasId=${id}`).then(() => {
						this.$message.success('删除成功')
						this.fetchList()
					}).catch(() => {
						this.$message.error('删除失败')
					})
				})
			}
		}
	}
</script>

<style scoped>
	.digital-human-page {
		height: 100%;
		padding: 10px;
		background-color: #f5f5f5;
	}

	.digital-human-list {
		background-color: #fff;
		border-radius: 16px;
		padding: 10px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
		min-height: calc(100%);
	}

	.list-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(187px, 1fr));
		gap: 8px;
	}

	.new-canvas-card {
		border-radius: 10px;
		overflow: hidden;
		cursor: pointer;
		transition: transform 0.3s ease, box-shadow 0.3s ease;
	}

	.new-canvas-card:hover {
		transform: translateY(-2px);
		box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
	}

	.new-canvas-bg {
		height: 120px;
		background: linear-gradient(135deg, #0ea5e9 0%, #06b6d4 30%, #10b981 60%, #84cc16 100%);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
		overflow: hidden;
	}

	.new-canvas-bg::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: radial-gradient(circle at 30% 20%, rgba(255, 255, 255, 0.15) 0%, transparent 50%),
			radial-gradient(circle at 70% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 40%);
	}

	.new-canvas-bg::after {
		content: '';
		position: absolute;
		top: -50%;
		left: -50%;
		width: 200%;
		height: 200%;
		background: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.05'/%3E%3C/svg%3E");
	}

	.new-canvas-icon {
		width: 37px;
		height: 37px;
		border-radius: 50%;
		background-color: rgba(255, 255, 255, 0.25);
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 8px;
		backdrop-filter: blur(8px);
		position: relative;
		z-index: 1;
		transition: transform 0.3s ease;
	}

	.new-canvas-card:hover .new-canvas-icon {
		transform: scale(1.1);
	}

	.new-canvas-icon i {
		font-size: 21px;
		color: #fff;
	}

	.new-canvas-text {
		font-size: 16px;
		font-weight: 600;
		color: #fff;
		position: relative;
		z-index: 1;
		text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}

	.new-canvas-desc {
		font-size: 13px;
		font-weight: 600;
		color: #333;
		padding: 8px 11px 3px;
	}

	.new-canvas-sub {
		font-size: 12px;
		color: #999;
		padding: 0 11px 11px;
	}

	.human-card {
		background-color: #fff;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
		cursor: pointer;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		position: relative;
		border: 1px solid #e5e7eb;
	}

	.human-card:hover {
		box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08), 0 4px 6px rgba(0, 0, 0, 0.06);
		transform: translateY(-2px);
	}

	.human-card.selected {
		border: 2px solid #4f46e5;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.1);
	}

	.card-preview {
		height: 118px;
		overflow: hidden;
		position: relative;
	}

	.card-preview .el-image {
		width: 100%;
		height: 100%;
	}

	.card-preview .preview-audio {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #f5f5f5;
	}

	.card-preview .preview-video {
		width: 100%;
		height: 100%;
	}

	.card-preview .preview-text {
		width: 100%;
		height: 100%;
		padding: 12px;
		background: #f5f5f5;
		font-size: 13px;
		line-height: 1.5;
		color: #333;
		display: flex;
		align-items: center;
	}

	.card-info {
		padding: 8px 11px;
	}

	.card-info h3 {
		font-size: 13px;
		font-weight: 600;
		color: #333;
		margin: 0 0 4px 0;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.card-time {
		font-size: 12px;
		color: #bbb;
		padding: 0 11px 8px;
	}

	.card-actions {
		position: absolute;
		top: 5px;
		right: 5px;
		display: flex;
		gap: 3px;
		opacity: 0;
		visibility: hidden;
		transform: translateX(5px);
		transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.human-card:hover .card-actions {
		opacity: 1;
		visibility: visible;
		transform: translateX(0);
	}

	.list-footer {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding: 10px;
		border-top: 1px solid #eee;
		margin-top: 10px;
	}

	.list-footer span {
		font-size: 13px;
		color: #999;
	}
</style>